"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _createSvgIcon = _interopRequireDefault(require("../createSvgIcon"));

var _PeopleBranch = _interopRequireDefault(require("@rsuite/icon-font/lib/people/PeopleBranch"));

// Generated by script, don't edit it please.
var PeopleBranch = (0, _createSvgIcon["default"])({
  as: _PeopleBranch["default"],
  ariaLabel: 'people branch',
  category: 'people',
  displayName: 'PeopleBranch'
});
var _default = PeopleBranch;
exports["default"] = _default;
module.exports = exports.default;